var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86 35.234h28.28c3.231 0 5.86-2.628 5.86-5.859v-18.75c0-3.23-2.629-5.86-5.86-5.86H5.86A5.866 5.866 0 0 0 0 10.626v18.75c0 3.23 2.629 5.86 5.86 5.86zm9.453-21.093a1.173 1.173 0 0 1 1.793-.994l9.375 5.86a1.172 1.172 0 0 1 0 1.986l-9.375 5.86a1.168 1.168 0 0 1-1.19.032 1.173 1.173 0 0 1-.604-1.026V14.141z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.196 18.752a1 1 0 0 1 0 1.726l-11.543 6.764a1 1 0 0 1-1.505-.863l.01-13.512a1 1 0 0 1 1.505-.863l11.533 6.748z",
    fill: "#252831"
  })));
};
export default SvgVideo;